<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-07-17 09:06:37
-->
<template>
  <div class="admin-edit-pwd">
    <Form ref="adminData"
          :model="adminInfo"
          :rules="adminValidate"
          action="javascript:void(0)">
      <FormItem label="密码( 密码需6-15位，必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _ )"
                prop="password">
        <Input v-model="adminInfo.password"
               type="password"
               placeholder="输入密码..."></Input>
      </FormItem>
      <FormItem label="确认密码">
        <Input v-model="adminInfo.password_confirmation"
               type="password"
               placeholder="确认密码..."></Input>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('adminData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
  
  
  <script>
import { dodgerblue } from 'color-name';
import { LOGOUT, LOGIN } from '../../.././vuex/mutation_types'
import md5 from "js-md5";
export default {
  name: 'admin-edit-pwd',
  data () {
    const pwdCheck = (rule, value, callback) => {
      let numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
      let englishAlphabet = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f',
        'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm'];
      let specialCharacters = ['!', '@', '#', '$', '%', '&', '.', '_'];
      let isNumber = false;
      let isEnglishAlphabet = false;
      let isBigEnglishAlphabet = false;
      let isSpecialCharacters = false;
      numbers.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isNumber = true;
        }
      });
      englishAlphabet.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isEnglishAlphabet = true;
        }
        if (value.indexOf(item.toUpperCase()) !== -1) {
          isBigEnglishAlphabet = true;
        }
      });
      specialCharacters.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isSpecialCharacters = true;
        }
      });
      if (isNumber && isEnglishAlphabet && isBigEnglishAlphabet && isSpecialCharacters) {
        callback();
      } else {
        callback(new Error("密码格式错误"));
      }
    };
    return {
      adminInfo: {
        password: '',
        password_confirmation: '',
      },
      adminValidate: {
        password: [
          { required: true, message: "密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur",
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
      },
    }
  },
  created: function () {
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.adminInfo.password != this.adminInfo.password_confirmation) {

            this.$Message.error("两次密码不一致");
            return;
          }
          this.$api.admin
            .editpassword({
              admin_id: this.$store.getters.user_id,
              password: md5(this.adminInfo.password),
              password_confirmation: md5(this.adminInfo.password_confirmation)
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.$store.commit(LOGOUT)
                // 跳转到登录
                this.$router.push('/');
              }
            });



          // var params = this.adminInfo;
          // params.admin_id = this.$store.getters.user_id;
          // this.$api.admin.selfeditpassword(params).then(res => {
          //   if (res.code == 200) {
          //     this.$Message.success('修改成功，请重新登录...');
          //     this.$store.commit(LOGOUT)
          //     // 跳转到登录
          //     this.$router.push('/');
          //   }
          // });
        } else {
          console.log(222);
        }
      })
    },
  }
}
  </script>